module.exports = __webpack_public_path__ + "img/reception1.b1d54d55.png";